var ImageData = /** @class */ (function () {
    function ImageData(width, height) {
        this.width = width;
        this.height = height;
        this.data = new Uint8Array(width * height * 4);
    }
    return ImageData;
}());
export { ImageData };
